import Lottie from "lottie-react";
import { useNavigate } from "react-router-dom";
import schoolViewIcon from "../../../../../assets/jsons/school_view.json";
import classroomViewIcon from "../../../../../assets/jsons/classroom_view.json";
import studentViewIcon from "../../../../../assets/jsons/student_view.json";
import sidebarToggleIcon from "../../../../../assets/Icons/sidebar.png";
import appHeaderLogo from "../../../../../assets/Icons/appHeaderLogo.png";
import resourcesIcon from "../../../../../assets/jsons/resources.json";
import storiesIcon from "../../../../../assets/jsons/stories.json";
import activitiesIcon from "../../../../../assets/jsons/activities.json";
import exploreAppIcon from "../../../../../assets/jsons/explore_app.json";
import "../../../Admin/components/AdminSidebar/AdminSidebar.scss";

const SECTIONS = [
  {
    label: "INSIGHTS",
    items: [
      { id: "SCHOOL_VIEW",    label: "School View",    icon: schoolViewIcon },
      { id: "CLASSROOM_VIEW", label: "Classroom View", icon: classroomViewIcon },
      { id: "STUDENT_VIEW",   label: "Student View",   icon: studentViewIcon },
    ],
  },
  {
    label: "CLASSROOM",
    items: [
      { id: "TROO_STORIES", label: "Troo stories", icon: storiesIcon },
      { id: "ACTIVITIES",   label: "Activities",   icon: activitiesIcon },
      { id: "EXPLORE_APP",  label: "Explore app",  icon: exploreAppIcon },
    ],
  },
];

type Props = {
  activeTab: string;
  onChange: (tab: string) => void;
  isCollapsed: boolean;
  onToggle: () => void;
};

const SuperAdminSidebar = ({ activeTab, onChange, isCollapsed, onToggle }: Props) => {
  const navigate = useNavigate();
  return (
    <aside className={`admin-sidebar${isCollapsed ? " collapsed" : ""}`}>
      <div className="sidebar-header">
        {!isCollapsed && (
          <img src={appHeaderLogo} alt="logo" className="sidebar-logo" />
        )}
        <button
          className="sidebar-toggle"
          onClick={onToggle}
          aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          title={isCollapsed ? "Expand" : "Collapse"}
        >
          <img src={sidebarToggleIcon} alt="toggle" width={48} height={48} />
        </button>
      </div>

      <nav className="sidebar-nav">
        {SECTIONS.map((section, sIdx) => (
          <div className="sidebar-section" key={section.label}>
            {sIdx > 0 && <div className="sidebar-divider" />}
            <span className="sidebar-section-label">{section.label}</span>
            {section.items.map(({ id, label, icon }) => (
              <button
                key={id}
                className={`sidebar-nav-item${activeTab === id ? " active" : ""}`}
                onClick={() => {
                  if (id === "EXPLORE_APP") {
                    navigate("/web/rooms");
                  } else {
                    onChange(id);
                    navigate(`/dashboard/${id.toLowerCase().replace(/_/g, "-")}`);
                  }
                }}
                title={isCollapsed ? label : undefined}
              >
                <span className="sidebar-icon">
                  <Lottie
                    animationData={icon}
                    loop
                    autoplay
                    style={{ width: 36, height: 36 }}
                  />
                </span>
                {!isCollapsed && <span className="sidebar-label">{label}</span>}
              </button>
            ))}
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default SuperAdminSidebar;
